import { ILocationService, ISCEService, ITimeoutService } from 'angular';
import { CommonService } from '@/app/common/common.service';
import angular, { IQService } from 'angular';
import { PasswordCollectorService } from '@/app/common/passwordCollector/services/passwordCollector.service';
import { IStateService } from 'angular-ui-router';
import { PopUpService } from '@/app/common/popup/popup.service';
import { JavaApiAdapterService } from '@/app/common/apiadapter/javaapi.service';
import { CacheService } from '@/app/common/service/cache.service';
import { PermissionService } from 'ecv/common/permissions';
import { TeamPermissionService } from '@/app/common/service/teamPermission.service';
import { PolicyTypeEnum, ValidationService } from '@/app/common/service/validation.service';
import { SubjectService } from '@/app/common/service/subject.service';
import { AuthenticationService } from '../../services/authentication.service';
import { Util } from '@/app/common/util';
import { Subject } from '@/app/common/model/subject';
import { User } from '@/app/common/model/user';
import { IAppRootScopeService } from '@/app/app.definition';

const auth = '';
export class SignupController {

    static $inject = ["$q",
        "CommonService", "$location", "baseUrl", "$rootScope",
        "PasswordCollectorService", "$state", "PopUpService",
        "ApiAdapterService", "$injector", "CacheService", "PermissionService",
        "$sce", "TeamPermissionService", "$timeout", "ValidationService", "SubjectService", "AuthenticationService"];

    constructor(
        $q: IQService,
        private CommonService: CommonService,
        private $location: ILocationService,
        private baseUrl: string,
        private $rootScope: IAppRootScopeService,
        private PasswordCollectorService: PasswordCollectorService,
        private $state: IStateService,
        private PopUpService: PopUpService,
        private ApiAdapterService: JavaApiAdapterService,
        private $injector: ng.auto.IInjectorService,
        private CacheService: CacheService,
        private permService: PermissionService,
        private $sce: ISCEService,
        private $_teamPerm: TeamPermissionService,
        private $timeout: ITimeoutService,
        private ValidationService: ValidationService,
        private SubjectService: SubjectService,
        private AuthenticationService: AuthenticationService
    ) {
        // Add type for $validationProvider to avoid 'unknown' type error
        const $validationProvider = $injector.get<any>('$validation');
        $rootScope.mainShowLoader = false;
        $rootScope.rootShowLoader = false;
        const signUpVm: any = this;
        signUpVm.baseUrl = baseUrl + 'src/client/app/common/privacy/privacyContent.html';
        signUpVm.providerTypeList = Util.getProviderTypeList();
        signUpVm.subject = new Subject();
        signUpVm.questions = Util.getQuestions();
        signUpVm.monthList = Util.getMonthList();
        signUpVm.dayList = Util.getDaysList();
        signUpVm.yearList = Util.getYearsList(null, true);
        signUpVm.professionList = Util.getProfessionList();
        signUpVm.noRecordsFound = Util.NO_MATCH_UISELECT;
        signUpVm.otherProfession = '';
        signUpVm.monthDropDown = {};
        signUpVm.flag = false;
        signUpVm.codeRequired = !!window.sessionStorage["ecvInvite"] ? true : false;//If the invite is from super admin secret code should not be a required field
        signUpVm.openCoveredEntity = PopUpService.openCoveredEntity;
        signUpVm.tooltipText = $sce.trustAsHtml("<html><body>We use your email address as a way to identify the user logging in. " +
            " We do not share any information about you or your activities on our site with Google or LinkedIn." +
            "<br /><br /> For more details, please see our Privacy Policy and Terms of Service below.</body></html>");
        signUpVm.VAULT_KEY_TXT = Util.VAULT_KEY_TXT;
        signUpVm.vkPolicyTooltip = "";
        signUpVm.hasVkError = false;
        signUpVm.vkErrorMsg = "";
        signUpVm.GDPR_COMPLIANCE_INFO = Util.GDPR_COMPLIANCE_INFO;
        signUpVm.GDPR_COMPLIANCE_DECLINE_CASE_INFO_SIGNUP = Util.GDPR_COMPLIANCE_DECLINE_CASE_INFO_SIGNUP;
        signUpVm.GDPR_COMPLIANCE_DECLINE_CONFIRMATION = Util.GDPR_COMPLIANCE_DECLINE_CASE_INFO_SIGNUP + " Would you like to continue?";

        $timeout(() => {
            (Util.getIEVersion() == -1) && angular.element('#firstName').focus();
        }, 0)


        signUpVm.monthChange = (month) => {
            signUpVm.daysList = Util.getDaysList(Util.getDaysFromMonth(month));
        }
        signUpVm.auth = CacheService.getAuthType();

        if (!!$location.search().for) {
            signUpVm.iFor = $location.search().for;

        } else if (!!$state.params['for']) {
            signUpVm.iFor = $state.params['for'];
        } else {
            signUpVm.iFor = null;
        }

        //default date
        const today = new Date();
        signUpVm.year = today.getFullYear();

        //Dropdowns
        signUpVm.city = Util.getCityList();
        signUpVm.state = Util.getStateList();
        signUpVm.numChild = Util.getNumberOfChildren();
        signUpVm.gender = Util.getGenderList();
        signUpVm.orgTypes = Util.getOrganizationTypeList();
        signUpVm.grades = Util.getGradeList();
        signUpVm.relationTypes = Util.getRelationships();

        signUpVm.stateName = $state.current.name;

        // Populate User form from what we have stored
        signUpVm.user = CacheService.getUser();

        if (!signUpVm.user) {
            signUpVm.user = new User();
        }
        if (!!signUpVm.user.firstName)
            signUpVm.user.fullName = signUpVm.user.firstName;
        if (!!signUpVm.user.lastName)
            signUpVm.user.fullName = signUpVm.user.fullName + ' ' + signUpVm.user.lastName;

        const processVKPolicy = () => {
            signUpVm.vkPolicyTooltip = this.ValidationService.getHtmlTooltip(PolicyTypeEnum.VAULT_KEY_POLICY);
            signUpVm.vkErrorMsg = this.ValidationService.getPwdErrMessage(PolicyTypeEnum.VAULT_KEY_POLICY);
            this.$sce.trustAsHtml(signUpVm.vkPolicyTooltip);
        }

        if (!ValidationService.get(PolicyTypeEnum.VAULT_KEY_POLICY)) {
            this.ApiAdapterService.getValidationPolicy(signUpVm.user.providerIdentity, null, PolicyTypeEnum.VAULT_KEY_POLICY).then((policies) => {
                this.ValidationService.setAndProcessPolicy(PolicyTypeEnum.VAULT_KEY_POLICY, policies.vaultKeyPolicy);
                processVKPolicy();
            });
        } else {
            processVKPolicy();
        }

        ApiAdapterService.getUserTypes().then(
            (data) => {
                signUpVm.userTypes = data;
                signUpVm.user.userTypeId = signUpVm.userTypes[1].id;
            },
            e => {
                console.log('error user type request get');
                console.log(e);
            }
        );

        signUpVm.initProvider = () => {
            signUpVm.user.approvedProvider = false;
        };

        signUpVm.proceedChild = (form) => {

            $validationProvider.validate(form)
                .success(signUpVm.addChild)
                .error(function (message) {
                    console.log("Validation Error:", message)
                });
        };

        signUpVm.checkTokenAPI = () => {
            const ecvInvite = window.sessionStorage["ecvInvite"];
            ApiAdapterService.checkToken(ecvInvite).then((s) => {
                CacheService.setTokenValidation(s);
                signUpVm.validateToken();
            });
        }

        signUpVm.validateToken = () => {
            const s = CacheService.getTokenValidation();
            if (s) {
                if (s.code != 'YES') {
                    signUpVm.codeRequired = false;
                    signUpVm.secretCode = "ECV";
                }
            }
        }

        signUpVm.validateToken();

        // redirect to login page
        signUpVm.goToLogin = () => {
            $rootScope.logout();
        }

        ApiAdapterService.getCountries().then(
            (s) => {
                signUpVm.countries = s;
                signUpVm.country = signUpVm.countries.find((country) => country.name == "United States of America");
            },
            e => {
                console.log('error getting country types');
                console.log(e);
            }
        );

        signUpVm.countryChange = () => {
            signUpVm.acceptedGdpr = false;
            signUpVm.user.termsOfService = false;
        }

        //method to agree GDPR Compliance: frontend only
        signUpVm.acceptGdprCompliance = () => {
            signUpVm.acceptedGdpr = true;
        }

        signUpVm.splitFullName = () => {
            const name = signUpVm.user.fullName.split(' ');
            signUpVm.user.firstName = name[0];
            signUpVm.user.lastName = (name[1] == undefined) ? "" : name[1];
        }

        signUpVm.isValidVaultKey = () => {
            signUpVm.hasVkError = !this.ValidationService.isValidValue(PolicyTypeEnum.VAULT_KEY_POLICY, signUpVm.user.password);
            return !signUpVm.hasVkError;
        };
        // On clicking proceed
        signUpVm.proceed = (form, role) => {
            const deferred = $q.defer();
            signUpVm.validating = true;
            signUpVm.showLoader = true;
            signUpVm.user.countryId = signUpVm.country.id;
            if (!signUpVm.isValidVaultKey()) {
                signUpVm.validating = false;
                signUpVm.showLoader = false;
                $validationProvider.validate(form);
                signUpVm.$timeout(() => {
                    $('#password').focus();
                }, 0);
                $timeout(() => {
                    deferred.reject();
                }, 500);
                return deferred.promise;;
            }

            $validationProvider.validate(form)
                .success(() => {
                    if (signUpVm.user.password != signUpVm.user.cPassword) {
                        signUpVm.validating = signUpVm.showLoader = false;
                        PopUpService.openInformationModal('Passwords do not match.');
                        $timeout(() => {
                            deferred.reject();
                        }, 500);
                        return deferred.promise;;
                    }
                    if (!!signUpVm.country.isEuCountry && !!signUpVm.acceptedGdpr) {
                        signUpVm.user.termsOfService = true;
                    }
                    if (!signUpVm.user.termsOfService) {
                        signUpVm.validating = signUpVm.showLoader = false;
                        PopUpService.openInformationModal('Must accept Privacy Policy and Terms of Service.');
                        $timeout(() => {
                            deferred.reject();
                        }, 500);
                        return deferred.promise;;
                    }

                    if (signUpVm.user.zip && (signUpVm.user.zip.length > 5 || signUpVm.user.zip.length < 5)) {
                        signUpVm.validating = signUpVm.showLoader = false;
                        PopUpService.openInformationModal('Zip code is invalid.');
                        $timeout(() => {
                            deferred.reject();
                        }, 500);
                        return deferred.promise;;
                    }

                    ApiAdapterService.validateSignup(signUpVm.user.providerIdentity, window.sessionStorage["ecvInvite"], signUpVm.codeRequired ? signUpVm.secretCode : null).then(
                        (s) => {
                            signUpVm.validating = signUpVm.showLoader = false;
                            if (!signUpVm.user.firstName || !signUpVm.user.lastName) {
                                PopUpService.openInformationModal("Oops! We need both first name and last name to continue.");
                                deferred.reject();
                                return deferred.promise;;
                            }
                            signUpVm.proceedSignup();
                            deferred.resolve();
                        },
                        (e) => {
                            signUpVm.validating = false;
                            signUpVm.showLoader = false;
                            PopUpService.openInformationModal(e);
                            deferred.reject();
                            if (e.indexOf('Api not instantiated') != -1)
                                $state.go('login');
                        })
                })
                .error(function (message) {
                    signUpVm.showLoader = false;
                    $rootScope.mainShowLoader = false;
                    signUpVm.validating = false;
                    console.log("Validation Error:", message);
                    $timeout(() => {
                        deferred.reject();
                    }, 500);
                    return deferred.promise;
                });
            return deferred.promise;
        };

        signUpVm.proceedSignup = () => {
            if (signUpVm.user.profession == 'Other') {
                if (signUpVm.otherProfession == '') {
                    PopUpService.openInformationModal('Please add profession.');
                    return;
                }

                signUpVm.user.profession = signUpVm.otherProfession;
            }

            signUpVm.showLoader = "Please wait while we create your account...";
            $rootScope.mainShowLoader = "Please wait while we create your account...";

            signUpVm.user.acceptedPrivacy = true;
            if (!!signUpVm.country.isEuCountry && !!signUpVm.acceptedGdpr) {
                signUpVm.user.acceptedGdpr = true;
                signUpVm.user.euCountry = true;
            }
            //if (signUpVm.stateName.indexOf('signup-parent') == -1) {
            signUpVm.user.approvedProvider = true;
            //}

            signUpVm.user.fullName = signUpVm.user.firstName + ' ' + signUpVm.user.lastName;
            const ecvInvite = window.sessionStorage["ecvInvite"];
            //const secretCode = signUpVm.secretCode;


            const userToSend = angular.copy(signUpVm.user);
            userToSend.password = CommonService.hashPassword(signUpVm.user.password);

            if (!!userToSend.photo) {
                if (userToSend.photo.indexOf('.jpg')) {
                    userToSend.photoMimeType = 'image/jpg';
                } else if (userToSend.photo.indexOf('.png')) {
                    userToSend.photoMimeType = 'image/png';
                }
            }

            //secretCode = signUpVm.codeRequired ? secretCode : '0000';
            ApiAdapterService.createUser(userToSend, ecvInvite).then(
                (data) => {
                    const auth_code = CacheService.getAuthCode();
                    const id_token = CacheService.getIdToken();

                    $rootScope.inviteDeleted = false;
                    $rootScope.organizationShortName = data.user.organizationShortName;
                    this.CacheService.setUser(data.user);
                    let welcome_msg = "Welcome! You are now part of the eCare Vault family!";

                    if (!!data && !!data.inviteInfo) {
                        $rootScope.inviteDeleted = true;
                        welcome_msg = welcome_msg + "<br /><br />The invitation to join this Team is no longer active. Create or join another Team to get started!";
                    }

                    const welcome_info_message = null;

                    ApiAdapterService.getIdentity().then(
                        (user: any) => {
                            $rootScope.showfirefoxErr = true;
                            user.googlePhoto = signUpVm.user.googlePhoto;
                            //set organizationShortName in
                            // user so that it will set in the cache because
                            // organizationShortName is not available in indentityCall
                            CacheService.setUser(user);
                            //Add the user's notification setting in the cache.
                            CacheService.setNotificationDisabledFlag(user.isNotificationDisabled);
                            let prm = AuthenticationService.loadLandingPage(user);
                            let userExperience = CacheService.getUserExperience();
                            $rootScope.organizationShortName = $rootScope.organizationShortName || (!!userExperience && userExperience.sponsor.orgShortName);
                            user.organizationShortName = $rootScope.organizationShortName;
                            CacheService.set('userOrgName', user.organizationName);
                            signUpVm.showLoader = false;
                            ApiAdapterService.getCurrentSubscribePlanForUser(false).then((s) => {
                                CacheService.setUserPlanType(s.planType);
                                CacheService.setMaxCncrntDwnld(s.maxConcurrentDownloads);
                                signUpVm.currentPlan = CacheService.getPInfo();
                                if (!signUpVm.currentPlan) {
                                    signUpVm.currentPlan = {};
                                }
                                signUpVm.currentPlan.planType = s.planType,
                                    signUpVm.currentPlan.maxCR = s.maxCR;
                                CacheService.setPInfo(signUpVm.currentPlan);
                                $rootScope.planType = s.planType;
                            }, (e) => {
                            });

                            if ($rootScope.inviteDeleted == true) { //Invalid invitation
                                PopUpService.openInformationModal(welcome_msg, null, 'msgWithInfo', welcome_info_message).then(
                                    (success) => {
                                        $rootScope.firstLogin = true;
                                        delete window.sessionStorage["ecvInvite"];
                                        signUpVm.showLoader = "Loading...";
                                        $rootScope.mainShowLoader = "Loading...";
                                        CacheService.setShowCoachMark(true);
                                        CacheService.setPassword(CommonService.hashPassword(signUpVm.user.password));
                                        prm.then(() => {
                                            $state.go('parent-carefeed');
                                            $rootScope.mainShowLoader = false;
                                        })
                                    }
                                );
                            } else { // self sign up or valid invitation
                                PopUpService.openInformationModal(welcome_msg).then(
                                    (success) => {
                                        $rootScope.firstLogin = true;
                                        signUpVm.showLoader = "Loading...";
                                        $rootScope.mainShowLoader = "Loading...";
                                        CacheService.setShowCoachMark(true);
                                        CacheService.setPassword(CommonService.hashPassword(signUpVm.user.password));
                                        prm.then(() => {
                                            $state.go('parent-carefeed');
                                            $rootScope.mainShowLoader = false;
                                        })
                                    }
                                );
                            }
                        }, (error) => {
                            $rootScope.mainShowLoader = false
                            console.log(error);
                            PopUpService.openInformationModal(error).then(
                                success => '',
                                error => ''
                            );
                            return;
                        }
                    );
                },
                (error) => {
                    $rootScope.mainShowLoader = false;
                    signUpVm.validating = signUpVm.showLoader = false;
                    console.log(error, 'error');
                    PopUpService.openInformationModal(error).then(
                        success => $rootScope.mainShowLoader = false,
                        error => console.log(error)
                    );
                }
            );
        };

        $rootScope.signUpCallback = signUpVm.signUpCallback = (role?) => { // On Click "SignUp Parent"

            if (signUpVm.iFor == 'parent') {
                role = 'parent';
            } else if (signUpVm.iFor == 'teammember') {
                role = 'teammember';
            } else if (signUpVm.iFor == 'provider') {
                role = 'provider';
            } else {
                role = 'parent';
            }

            if (!signUpVm.user)
                signUpVm.user = new User();

            //});
        }

        signUpVm.croppedImage = '';

        signUpVm.addPhoto = function ($files, $errFiles) {
            signUpVm.photoPath = $files;

            if (signUpVm.stateName.indexOf('signup-parent') != -1) {
                $state.go('signup-parent-photo');
            } else {
                $state.go('signup-provider-photo');
            }
        };

        signUpVm.setPhoto = function () { };

        signUpVm.debug = () => {
            console.log(signUpVm.photoPath);
        };

        signUpVm.openPasswordModal = () => {
            if (signUpVm.isChecked && (!CacheService.getUser().policies || CacheService.getUser().policies.length == 0)) {
                PasswordCollectorService.openInitPasswordsModal(true);
            }
        }

        signUpVm.highlightLabel = () => {
            angular.element('.lblPrimaryUse').css('color', Util.COLORS.ecvBlue);
        }

        signUpVm.unHighlightLabel = () => {
            angular.element('.lblPrimaryUse').css('color', Util.COLORS.lightText);
        }
    }
}

angular.module('eCareVault.authentication')
    .controller('SignupController', SignupController);
